import * as React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { HStack, Primitive, atoms } from '@rtkwlf/fenrir-react';
import { faExternalLink } from '@rtkwlf/pro-solid-svg-icons/faExternalLink';

interface ExternalTextLinkProps {
  href: string;
  text: string;
}

const externalTextLink = atoms({
  textDecoration: 'none',
  wordBreak: 'break-all',
  textColor: 'body',
});

const externalLinkIcon = atoms({
  textColor: 'infoDefault',
  paddingLeft: 'small',
});

export const ExternalTextLink: React.FunctionComponent<
  React.PropsWithChildren<ExternalTextLinkProps>
> = ({ href, text }) => {
  return (
    <HStack>
      <Primitive.a
        className={externalTextLink}
        rel="noreferrer noopener"
        target="_blank"
        href={href}
      >
        {text}
        <FontAwesomeIcon
          className={externalLinkIcon}
          icon={faExternalLink}
          style={{ boxSizing: 'content-box' }}
        />
      </Primitive.a>
    </HStack>
  );
};
